import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar, FiArrowRight, FiFileText } from 'react-icons/fi';
import PageWrapper from '../../components/PageWrapper';
import { fetchNoticeList } from '../../api/notice';
import { mapNoticeListItem } from '../../utils/noticeHelper';
import './Notices.css';

const Notices = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeCategory, setActiveCategory] = useState('全部');

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError('');

    fetchNoticeList()
      .then((data) => {
        if (!alive) return;
        const rows = data?.rows || [];
        const list = rows
          .map(mapNoticeListItem)
          .sort((a, b) => (b.date || '').localeCompare(a.date || ''));
        setNotices(list);
      })
      .catch(() => {
        if (!alive) return;
        setError('公告列表加载失败，请稍后重试');
        setNotices([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, []);

  const categories = useMemo(() => {
    const used = Array.from(
      new Set(notices.map((item) => item.category).filter(Boolean))
    );
    return ['全部', ...used];
  }, [notices]);

  const filtered = useMemo(() => {
    if (activeCategory === '全部') return notices;
    return notices.filter((item) => item.category === activeCategory);
  }, [activeCategory, notices]);

  return (
    <PageWrapper className="notices-page">
      <section className="notices-hero">
        <div className="container">
          <div className="hero-eyebrow">
            <FiFileText />
            NOTICE
          </div>
          <h1>通知公告</h1>
          <p>招标公告、中选公示及相关文件</p>
        </div>
      </section>

      <section className="notices-content">
        <div className="container">
          <div className="notices-filters">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                className={`filter-chip ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {loading && <div className="notices-empty">正在加载公告...</div>}
          {!loading && error && <div className="notices-empty">{error}</div>}

          {!loading && !error && (
            <div className="notices-list">
              {filtered.map((notice) => (
                <Link
                  key={notice.contentId}
                  to={`/notices/${notice.slug}`}
                  state={{
                    catalogId: notice.catalogId,
                    title: notice.title,
                    category: notice.category,
                    date: notice.date,
                  }}
                  className="notice-item"
                >
                  <div className="notice-item-main">
                    <div className="notice-meta">
                      <span className="notice-category">{notice.category}</span>
                      {notice.date && (
                        <span className="notice-date">
                          <FiCalendar />
                          {notice.date}
                        </span>
                      )}
                    </div>
                    <h2>{notice.title}</h2>
                  </div>
                  <span className="notice-arrow" aria-hidden="true">
                    <FiArrowRight />
                  </span>
                </Link>
              ))}

              {filtered.length === 0 && (
                <div className="notices-empty">暂无该分类下的公告</div>
              )}
            </div>
          )}
        </div>
      </section>
    </PageWrapper>
  );
};

export default Notices;
